// src/utils/account.js
// Group and role labels shown in the header, user menu and My profile.
// They come from the portal database through /portal/user-info (userInfo);
// the email domain is only a fallback while that is loading.

export const SUPER_ADMIN_DOMAIN = 'crazypixels.org';
// The only Super Admin addresses (3.10); other crazypixels.org addresses are
// ordinary people in an account (e.g. webadmin@, shanthi@)
export const SUPER_ADMIN_EMAILS = ['admin@crazypixels.org', 'fax@crazypixels.org', 'support@crazypixels.org'];

export function isSuperAdminEmail(email) {
  return SUPER_ADMIN_EMAILS.includes(String(email || '').trim().toLowerCase());
}

export function isSuperAdmin(userInfo, email) {
  return userInfo?.roleId ? userInfo.roleId === 'super_admin' : isSuperAdminEmail(email);
}

// Super Admins, group Admins and Managers can open User Management
export function canManageUsers(userInfo, email) {
  return isSuperAdmin(userInfo, email) || ['master_admin', 'admin', 'manager'].includes(userInfo?.roleId);
}

// The account picked in the header switcher (3.0), else their group
export function groupLabelFor(email, userInfo) {
  if (userInfo?.accountId === 'all') return 'All clients';
  const picked = (userInfo?.accounts || []).find(a => a.id === userInfo?.accountId);
  if (picked) return picked.name;
  if (userInfo?.groupLabel) return userInfo.groupLabel;
  return isSuperAdminEmail(email) ? 'All clients' : '';
}

export function roleLabelFor(email, userInfo) {
  if (userInfo?.roleId) return userInfo.role;
  return isSuperAdminEmail(email) ? 'Super Admin' : 'User';
}
